import { defineStore } from 'pinia'
import { ref } from 'vue'
import { i18n, isAppLocale, type AppLocale } from '@/i18n'

export const useLocaleUiStore = defineStore(
  'localeUi',
  () => {
    const code = ref<AppLocale>('de')

    function setLocale(next: AppLocale): void {
      code.value = next
      i18n.global.locale.value = next
    }

    /** Call once after Pinia hydration so i18n matches persisted locale. */
    function syncI18n(): void {
      if (isAppLocale(code.value)) {
        i18n.global.locale.value = code.value
      }
    }

    return { code, setLocale, syncI18n }
  },
  {
    persist: {
      key: 'tb_admin_ui_locale',
      storage: localStorage,
      paths: ['code'],
    },
  },
)
